<template>
    <div>
        <el-card>
            <card-header :title="$t('usersCreate')" />
            <form>
                <InputField
                    :label="$t('usersName')"
                    :error="errors.name ? errors.name[0] : ''" 
                    v-model="newUser.name"/>
                <InputField
                    :label="$t('usersEmail')"
                    :error="errors.email ? errors.email[0] : ''" 
                    v-model="newUser.email"/>
                <SelectField placeholder="Select.." 
                    :label="$t('usersRole')"
                    :data="rolesData"
                    optionLabel="name"
                    optionValue="name"
                    v-model="value" />
                <InputField
                    :label="$t('usersPassword')"
                    typeField="password" 
                    :error="errors.password ? errors.password[0] : '' "
                    v-model="newUser.password"/>
                <InputField
                    :label="$t('usersPasswordConfirm')"
                    typeField="password"
                    :error="errors.password_confirmation ? errors.password_confirmation[0] : ''"
                    v-model="newUser.password_confirmation"/>
                
                <shared-buttons discardPath="Users" @confirm-event-fired="checkConfirmPassword(newUser)"/>
            </form>
        </el-card>
    </div>
</template>

<script>
    import api from '@/api/api';
    import {mapGetters, mapActions} from 'vuex';
    import {success, forbidden, warning} from '../Notification/notification';
    import {discard} from '@/helpers/helpers';
    import InputField from '../Inputs/InputField'
    import SelectField from '../Inputs/SelectField'
    import { bus } from "../../Bus";
    import CardHeader from '../LayoutPart/CardHeader'

    export default {
        components: {
            InputField,
            SelectField,
            CardHeader
        },
        computed: {
            ...mapGetters({
                roles: 'getRoles',
                authToken: 'getAuthToken'
            }),
            ...mapActions([
                'addUser'
            ])
        },
        async created() {
            await this.getRoles();
        },
        watch: {
            value () {                
            }
        },
        data() {
            return {
                rolesData: [],
                errors: {},
                value: '',
                newUser: {
                    id: null,
                    name: '',
                    email: '',
                    password: '',
                    password_confirmation: ''
                }
            }
        },
        methods: {
            discard,
            success,
            forbidden,
            warning,
            checkConfirmPassword(user) {
                if (!user.password_confirmation || !user.password) {
                    this.warning('You need to confirm your password.')
                } else if (user.password_confirmation !== user.password) {
                    this.warning('Passwords do not match.')
                } else {
                    this.saveUser()
                }

            },
            async getRoles() {
                await this.$store.dispatch('fetchRoles').then(() => {
                    this.rolesData = this.roles;
                })
            },
            saveUser() {
                this.errors = {}                     
                const roles = [];
                const roleObj = {
                    name: this.value,
                    type: 'role'
                };
                roles.push(roleObj);
                Object.assign(this.newUser, {roles});

                if (this.value !== '') {
                    api.saveUsers(this.newUser).then(res => {
                        const id = res.data.data.id;
                        const initialData = this.initialState();

                        api.saveUserRoles(id, {name: this.value}).then(() => {
                            this.newUser.id = id;

                            if (res.status === 200 || res.status === 201) {
                                this.$store.dispatch('addUser', this.newUser);

                                this.success('User', 'added');
                                this.discard('newUser')
                                this.value = ''
                                this.$router.push('/dashboard/users');

                                for (let prop in initialData) {
                                    // Reset the prop locally.
                                    this[prop] = initialData[prop];
                                }
                            }
                        })
                    }).catch(err => {
                        const error = err.data;
                        console.log(error);
                        
                        if (error.type === 'validation_error') {
                            this.warning('Please fill out required fields.');
                            this.errors = error.fields
                        }
                    });
                } else {
                    this.warning('Please select this users role to continue')
                }
            },
            initialState() {
                return {
                    newUser: {
                        id: null,
                        name: '',
                        email: '',
                        password: '',
                        password_confirmation: ''
                    },
                    value: ''
                }
            }
        }
    }
</script>

<style scoped>
    .block {
        display: inline-block;
    }

    .right {
        float: right;
    }

    .input-field {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .input-error {
        border: 1px solid red;
        border-radius: 5px;
    }

    .button {
        margin-left: 10px;
    }

</style>







// WEBPACK FOOTER //
// src/components/Users/CreateUser.vue